import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const rescuePanelSplitArmSchema = z.object({
  weight: z.number(),
  enabled: z.boolean(),
  dropoffPercentageTrigger: z.number().min(0).max(100).optional(),
  secondsInColdTrigger: z.number().optional(),
  spotlightId: z.string().optional(),
});

export const startRescuePanelSplit = {
  name: "startRescuePanelSplit" as const,
  input: z.object({
    teamId: zExt.objectId(),
    armA: rescuePanelSplitArmSchema,
    armB: rescuePanelSplitArmSchema,
    merchantDashboardVisible: z.boolean(),
  }),
  output: z.void(),
};
